module.exports = __webpack_public_path__ + "static/media/round-triangle-small.b5668a23.svg";